import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'upload-component',
	template: require('./upload-component.html')
})
export class UploadComponent {
	@Input() classComponent: string;
	@Input() placeholder: string;
	@Input() disabled = false;
	@Input() fileType: string;
	@Input() componentId: string;
	@Output() action: EventEmitter<any> = new EventEmitter();

	constructor(private messageService: MessageService) {}

	onFileChange(event) {
		if (
			event.target.files &&
			event.target.files.length > 0 &&
			event.target.value !== ''
		) {
			const file = event.target.files[0];
			if (this.validationXmlFile(file)) {
				this.action.emit(file);
			}
			event.target.value = '';
		}
	}

	validationXmlFile(file) {
		let validation = true;
		if (file.size === 0) {
			this.messageService.showToaster('e_12', 'fundy');
			validation = false;
		} else if (file.size >= 5000000) {
			// 5mb
			this.messageService.showToaster('e_6', 'fundy');
			validation = false;
		} else if (file.type !== 'text/xml') {
			this.messageService.showToaster('e_5', 'fundy');
			validation = false;
		}

		return validation;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/upload-component/upload-component.ts